import { render, staticRenderFns } from "./PlayAlert.vue?vue&type=template&id=5a3d8ba4&scoped=true"
import script from "./PlayAlert.vue?vue&type=script&lang=js"
export * from "./PlayAlert.vue?vue&type=script&lang=js"
import style0 from "./PlayAlert.vue?vue&type=style&index=0&id=5a3d8ba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3d8ba4",
  null
  
)

export default component.exports